import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { TipBox, TipWrap, useTip } from "./Tip";

export type PSeg = { value: number; color: string; title: string };
const nf = (x: number) => (Math.abs(x ?? 0) >= 100000
  ? Intl.NumberFormat("id-ID", { notation: "compact", maximumFractionDigits: 1 }).format(x)
  : Intl.NumberFormat("id-ID").format(x ?? 0));
const penuh = (x: number) => Intl.NumberFormat("id-ID").format(x ?? 0);

/** Baris progres: nama + nilai + persen dari total, bar tersegmen per tone.
 *  Persen ditulis eksplisit supaya identitas tidak bergantung warna saja. */
export function ProgressRow({ name, href, total, share, maxShare, segs }: {
  name: ReactNode; href?: string; total: number; share: number; maxShare?: number; segs: PSeg[];
}) {
  const { wrapRef, tip, tipUntuk } = useTip();
  // lebar bar = besaran relatif thd baris terbesar (peringkat terbaca sekilas),
  // isi bar = komposisi tone. Persen tetap ditulis supaya tidak bergantung warna.
  const w = `${Math.max(8, (share / (maxShare || share || 1)) * 100)}%`;
  const isi = {
    judul: name,
    baris: [
      { label: `${share.toFixed(1).replace(".", ",")}% dari total`, nilai: penuh(total) },
      ...segs.filter((s) => s.value > 0).map((s) => ({ warna: s.color, label: s.title, nilai: penuh(s.value) })),
    ],
  };
  const body = (
    <>
      <span className="avio-prow__head">
        <span className="avio-prow__name">{name}</span>
        <span className="avio-prow__val">{nf(total)}</span>
        <span className="avio-prow__pct">{share.toFixed(1).replace(".", ",")}%</span>
      </span>
      <span className="avio-prow__track" style={{ width: w }}>
        {segs.filter((s) => s.value > 0).map((s, i) => (
          <span key={i} className="avio-prow__fill" style={{ flex: s.value, background: s.color }} />
        ))}
        {total === 0 && <span className="avio-prow__fill" style={{ flex: 1, background: "var(--mark-grid)" }} />}
      </span>
    </>
  );
  return (
    <TipWrap wrapRef={wrapRef}>
      {href
        ? <Link to={href} className="avio-prow" {...tipUntuk(isi)}>{body}</Link>
        : <div className="avio-prow" {...tipUntuk(isi)}>{body}</div>}
      <TipBox tip={tip} />
    </TipWrap>
  );
}
